export const defaultProductMargin = 39.00
export const defaultPaymentConditionId = 1
